export default class TicketQueueEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#ticket_queue_uuid") ? (elem.querySelector("#ticket_queue_uuid") as HTMLInputElement).value : null,
            name: (elem.querySelector("#ticket_queue_name") as HTMLInputElement).value,
            // @ts-ignore
            members: elem.querySelector("#ticket_queue_new_members") ? Array.from(elem.querySelectorAll("#ticket_queue_new_members option:checked")).map(o => o.value) : Array.from(elem.querySelectorAll("#ticket_queue_members option:checked")).map(o => o.value)
        }
    }
}